import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    integrationsDeleteCerebrumXRequest,
    clearRedux,
} from 'Redux/actions';


const DeletePackage = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, loading, result, companyIntegrationId, fleetId } = useSelector(state => state.deleteCerebrumXIntegrationRedux)

    const closeModal = () => {
        dispatch(clearRedux("DELETE_CEREBRUMX_INTEGRATION"))
    }

    const applyChanges = () => {
        dispatch(integrationsDeleteCerebrumXRequest({ companyIntegrationId, fleetId }));
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['integrations_delete_cerebrumx_success_message'],
                    messages['integrations_delete_cerebrumx_title'],
                    3000,
                );
                tableRef && tableRef?.current?.getData();
                closeModal();
            } else {
                let message = messages['integrations_delete_cerebrumx_error_message']
                if (result && result?.error && result?.error?.includes("in use")) {
                    message = messages['integrations_delete_cerebrumx_in_use']
                }

                NotificationManager.error(
                    message,
                    messages['integrations_delete_cerebrumx_title'],
                    3000,
                );
                dispatch(clearRedux("DELETE_CEREBRUMX_INTEGRATION", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['integrations_delete_cerebrumx_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <p>{messages['integrations_delete_cerebrumx_description']}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default DeletePackage;